const DUEDATE = 'DUEDATE';
const STATUS = 'STATUS';
const USERS = 'USERS';
const TITLE = 'Tickets with Due Date older than';
// eslint-disable-next-line quotes
const TITLE_RESOLVED_TODAY = "Today's Activity";
const TICKETS_COUNT = 'Tickets Count';
const NUMBER_OF_TICKETS = 'Number of Tickets';
const BACK = '< Back';
const DUEDATE_FILTER_LIST = [
    'PastDue',
    'DueToday',
    'DueTomorrow',
    'DueAfterTomorrow',
    'Open',
    'Resolved',
    'UpdatedToday',
];
const STATUS_FILTER_LIST = ['Open', 'UpdatedToday', 'Resolved'];
const TODAYS_ACTIVITY_LIST = ['Open', 'Resolved'];
// eslint-disable-next-line quotes
const REPORTS_DROP_DOWN_OPTIONS = ['Upcoming Due Dates', "Today's Activity"];

export const CHART_TYPE = {
    ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY: 'ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY',
    ACTIVATE_WORKGROUP_BY_TAG_DUEDATE_RESOLVED_TODAY: 'ACTIVATE_WORKGROUP_BY_TAG_DUEDATE_RESOLVED_TODAY',
    ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_TAG_DRILL_DOWN:
        'ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_TAG_DRILL_DOWN',
    ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_DRILL_DOWN:
        'ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_DRILL_DOWN',
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE: 'RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE',
    RESOLVED_DATE_REPORTS_TAG_GROUP_BY_ASSIGNEE: 'RESOLVED_DATE_REPORTS_TAG_GROUP_BY_ASSIGNEE',
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN:
        'RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN',
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_TAG_DRILL_DOWN:
        'RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_TAG_DRILL_DOWN',
    ACTIVATE_WORKGROUP_BY_DUEDATE: 'ACTIVATE_WORKGROUP_BY_DUEDATE',
    ACTIVATE_WORKGROUP_BY_STATUS: 'ACTIVATE_WORKGROUP_BY_STATUS',
    ACTIVATE_DUEDATE_BY_USERS: 'ACTIVATE_DUEDATE_BY_USERS',
    ACTIVATE_STATUS_BY_USERS: 'ACTIVATE_STATUS_BY_USERS',
    ACTIVATE_WORKGROUP: 'ACTIVATE_WORKGROUP',
    DUE_DATE_REPORTS_ASSIGNEE_STATUS: 'DUE_DATE_REPORTS_ASSIGNEE_STATUS',
    DUE_DATE_REPORTS_ASSIGNEE_DUE_DATE: 'DUE_DATE_REPORTS_ASSIGNEE_DUE_DATE',
    DUE_DATE_REPORTS_ASSIGNEE_STATUS_DRILLDOWN: 'DUE_DATE_REPORTS_ASSIGNEE_STATUS_DRILLDOWN',
    DUE_DATE_REPORTS_ASSIGNEE_DUE_DATE_DRILLDOWN: 'DUE_DATE_REPORTS_ASSIGNEE_DUE_DATE_DRILLDOWN',
    DUE_DATE_REPORTS_BY_WORKGROUP_TAGS_STATUS: 'DUE_DATE_REPORTS_BY_WORKGROUP_TAGS_STATUS',
    DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_STATUS: 'DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_STATUS',
    DUE_DATE_REPORTS_BY_WORKGROUP_TAGS_DUE_DATE: 'DUE_DATE_REPORTS_BY_WORKGROUP_TAGS_DUE_DATE',
    DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_DUE_DATE: 'DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_DUE_DATE',
    DUE_DATE_REPORTS_BY_WORKGROUP_TAGS_DUE_DATE_DRILL_DOWN: 'DUE_DATE_REPORTS_BY_WORKGROUP_TAGS_DUE_DATE_DRILL_DOWN',
    DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_DUE_DATE_DRILL_DOWN: 'DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_DUE_DATE_DRILL_DOWN',
    DUE_DATE_REPORTS_BY_WORKGROUP_TAGS_STATUS_DRILL_DOWN: 'DUE_DATE_REPORTS_BY_WORKGROUP_TAGS_STATUS_DRILL_DOWN',
    DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_STATUS_DRILL_DOWN: 'DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_STATUS_DRILL_DOWN',
    DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_STATUS_DRILL_DOWN_USER:
        'DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_STATUS_DRILL_DOWN_USER',
    DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_DUE_DATE_DRILL_DOWN_USER:
        'DUE_DATE_REPORTS_BY_ASSIGNEE_TAGS_DUE_DATE_DRILL_DOWN_USER',
};

export const SEGMENT_BY = {
    ASSIGNEE: 'Assignee',
    WORKGROUP: 'Workgroup',
    TAB_DUE_DATE: 'Due Date',
    TAB_STATUS: 'Status',
    USER: 'User',
    TAG: 'Tag',
};

export const CHART_COLORS = {
    RESOLVED_DATE_REPORTS_COLOR: ['#FFFF00', '#9999A9'],
    DUEDATE_DATE_REPORTS_COLOR: ['#FF3333', '#FE9A2E', '#F3F781', '#5FB404'],
    STATUS_REPORTS_COLOR: ['#FF3333', '#FFFF00', '#9999A9'],
};

export const REPORT_TYPE = {
    UPCOMING_DUE_DATES: 'Upcoming Due Dates',
};

export const SHOWBY_OPTIONS = [
    { text: SEGMENT_BY.WORKGROUP, value: SEGMENT_BY.WORKGROUP, id: 0 },
    { text: SEGMENT_BY.ASSIGNEE, value: SEGMENT_BY.ASSIGNEE, id: 1 },
];

export const CHART_CONST_INFO = {
    DUEDATE,
    STATUS,
    TITLE,
    USERS,
    SEGMENT_BY,
    TICKETS_COUNT,
    NUMBER_OF_TICKETS,
    BACK,
    DUEDATE_FILTER_LIST,
    STATUS_FILTER_LIST,
    REPORTS_DROP_DOWN_OPTIONS,
    TITLE_RESOLVED_TODAY,
    TODAYS_ACTIVITY_LIST,
};
